import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { ColorRing } from 'react-loader-spinner';

import AnaliticsTitle from './AnaliticsTitle/AnaliticsTitle';
import MCTPage from './MCTPage';
import SBSPage from './SBSPage';
import VulsPage from './VulsPage';
import SightsPage from './SightsPage';

import { AnaliticsTableType } from 'components/AnalyticsPage/AnalyticsPageTypes';
import { useAppSelector } from 'slices';
import { TrapType } from 'components/AnalyticsPage/TrapType';
import useGetObjectTraps from 'hooks/Analitics/ObjectTraps/useGetObjectTraps';

interface ObjectAnaliticsProps {
  children?: React.ReactNode;
  currentPage: string;
  pageName: string;
}

function CustomTabPanel(props: ObjectAnaliticsProps) {
  const { children, currentPage, pageName } = props;

  return (
    <div hidden={currentPage !== pageName} id={`Page-${pageName}`}>
      {currentPage === pageName && <>{children}</>}
    </div>
  );
}

const ObjectAnalitics: React.FC = () => {
  const { slug } = useParams();
  const currentPage = useAppSelector(state => state.Analitics.currentAnalyticsPage);
  const { data: objectTraps, refetch, isFetching } = useGetObjectTraps(slug!, !!slug);

  useEffect(() => {
    refetch();
  }, [slug, refetch]);

  if (isFetching || !objectTraps)
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '350px' }}>
        <ColorRing
          visible
          height="80"
          width="80"
          ariaLabel="color-ring-loading"
          wrapperStyle={{}}
          wrapperClass="color-ring-wrapper"
          colors={['#9C7AE2', '#E27A8C', '#C0E27A', '#7AE2D0', '#F7F18F']}
        />
      </div>
    );

  return (
    <div>
      <AnaliticsTitle objectTraps={objectTraps} />
      <CustomTabPanel currentPage={currentPage} pageName={AnaliticsTableType.MouseTrapsAnalytics}>
        <MCTPage
          slug={slug || ''}
          trapType={
            objectTraps.mct.was_ever_installed
              ? objectTraps.smst.was_ever_installed
                ? TrapType.ALL
                : TrapType.MCT
              : TrapType.SMST
          }
          objectTraps={objectTraps}
        />
      </CustomTabPanel>
      <CustomTabPanel currentPage={currentPage} pageName={AnaliticsTableType.RatTrapsAnalytics}>
        <MCTPage slug={slug || ''} trapType={TrapType.SRST} objectTraps={objectTraps} />
      </CustomTabPanel>
      {objectTraps?.srbm.was_ever_installed && (
        <CustomTabPanel currentPage={currentPage} pageName={AnaliticsTableType.SmartRodentBaitModule}>
          <SBSPage slug={slug || ''} trapType={TrapType.SRBM} />
        </CustomTabPanel>
      )}
      <CustomTabPanel currentPage={currentPage} pageName={AnaliticsTableType.Vulnerabilities}>
        <VulsPage slug={slug || ''} />
      </CustomTabPanel>
      <CustomTabPanel currentPage={currentPage} pageName={AnaliticsTableType.Sights}>
        <SightsPage slug={slug || ''} />
      </CustomTabPanel>
    </div>
  );
};

export default ObjectAnalitics;
